import { findAll } from '../utils/dom'

const EditorJS = () => {
	const EditorSimples = findAll('[js-editor-simples]')

	/** Para adicionar texto no front de maneira simples */
	if (EditorSimples) {
		EditorSimples.forEach((editor) => {
			if (editor.innerText) {
				let Texto = JSON.parse(editor.innerText)
				let ResultText = ''
				let TotalParagraph = Texto.blocks.length

				for (let i = 0; i < TotalParagraph; i++) {
					if (TotalParagraph > 0) {
						ResultText += `${Texto.blocks[i].data.text} <br />`
					} else {
						ResultText = `${Texto.blocks[i].data.text}`
					}
				}

				editor.innerHTML = ResultText
			}
		})
	}

	const EditorTags = findAll('[js-editor-tags]')

	if (EditorTags) {
		EditorTags.forEach((editor) => {
			if (editor.innerText) {
				let Texto = JSON.parse(editor.innerText)
				let ResultText = ''
				let TotalTag = Texto.blocks.length

				for (let i = 0; i < TotalTag; i++) {
					const Tipo = Texto.blocks[i].type
					if (Tipo == 'paragraph') {
						let ParagraphTexto = Texto.blocks[i].data.text
						ResultText += `<p>${ParagraphTexto}</p>`
					}
					if (Tipo == 'Header') {
						const Level = Texto.blocks[i].data.level
						ResultText += `<h${Level}>${Texto.blocks[i].data.text}</h${Level}>`
					}

					if (Tipo == 'List') {
						const Items = Texto.blocks[i].data.items
						const Estilo = Texto.blocks[i].data.style
						let Lista = `<ul class="${Estilo}">`
						for (let Item of Items) {
							Lista += `<li>${Item}</li>`
						}
						Lista += `</ul>`
						ResultText += Lista
					}
					if (Tipo == 'Delimiter') {
						ResultText += `<br />`
					}
				}

				editor.innerHTML = ResultText
			}
		})
	}
}

export default EditorJS
